

export enum OrganizationActionTypes {
    SET_ORGANIZATIONS = 'SET_ORGANIZATIONS',
}

export interface Organization {
    billing_address_effective_date?: string | undefined;
    fax_phone_number?: string | undefined;
    billing_city?: string | undefined;
    billing_guid?: string | undefined;
    Note?: string | undefined;
    welcome_mission_statement?: string | undefined;
    fax_phone_extension?: string | undefined;
    billing_address_3?: string | undefined;
    ue_id?: string | undefined;
    org_hierarchy_start_date?: string | undefined;
    organization_name: string;
    isMatchOrganization?: boolean | undefined;
    org_type: string;
    seating_capacity?: number | undefined;
    service_times?: string | undefined;
    physical_address_effective_date?: string | undefined;
    physical_address_expiration_date?: string | undefined;
    physical_guid?: string | undefined;
    business_email_address?: string | undefined;
    physical_city?: string | undefined;
    founded_year?: number | undefined;
    school_indicator?: string | undefined;
    billing_country?: string | undefined;
    sunday_school_indicator?: string | undefined;
    closed_year?: number | undefined;
    physical_address_3?: string | undefined;
    business_phone_number?: string | undefined;
    billing_address_expiration_date?: string | undefined;
    appURL?: string | undefined;
    research_comments?: string | undefined;
    closed_indicator?: string | undefined;
    parish_description?: string | undefined;
    tec_flag?: string | undefined;
    physical_country?: string | undefined;
    billing_address_2?: string | undefined;
    seasonal_institution?: string | undefined;
    fax_phone_country_code?: string | undefined;
    physical_state?: string | undefined;
    foreign_institution?: string | undefined;
    billing_postal_code?: string | undefined;
    website_url?: string | undefined;
    dfms_filing_status?: string | undefined;
    business_phone_country_code?: string | undefined;
    org_hierarchy_end_date?: string | undefined;
    physical_address_2?: string | undefined;
    org_hierarchy_type?: string | undefined;
    fax_phone_area_code?: string | undefined;
    business_phone_area_code?: string | undefined;
    special_programs?: string | undefined;
    billing_state?: string | undefined;
    congregation_size?: number | undefined;
    _guid?: string | undefined;
    known_as?: string | undefined;
    billing_address_1?: string | undefined;
    parent_org_client_nbr?: string | undefined;
    physical_postal_code?: string | undefined;
    org_category: string;
    business_phone_extension?: string | undefined;
    physical_address_1?: string | undefined;
    tax_id?: string | undefined;
}

export interface OrganizationState {
    organization: Organization;
}
